/**
 * @desc 客户类型列表
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/common/customerType`, {
      method: "GET",

      ...options,
    }),
  );
}
